// import { useEffect, useState } from 'react';

// material-ui
// import { useMediaQuery, useTheme } from '@mui/material';

// project-imports
// import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
// import { useSelector } from 'store';
// import useAuth from 'hooks/useAuth';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  // const theme = useTheme();
  // const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  // const { drawerOpen } = useSelector((state) => state.menu);
  // const { user } = useAuth();

  // const [trial, setTrial] = useState(false);

  // useEffect(() => {
  //   if (user?.currentPlan?.includes('trial')) {
  //     setTrial(true);
  //   }
  // }, [user?.currentPlan]);

  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <>
        <Navigation />
        {/* {drawerOpen && trial && <NavCard />} */}
      </>
    </SimpleBar>
  );
};

export default DrawerContent;
